module.exports = __webpack_public_path__ + "static/media/rectangle-landscape.96f49ab9.svg";